<form #form="ngForm" column-classes="col-md-6, col-md-6">
  @if (exportKriterien) {
    <div class="row mt-2">
      @if (exportKriterien.mExportGrundstueckbeschreibung.access !== "DEACTIVATED") {
        <div class="col-6">
          <cap-select-grundstueckbeschreibung [disabled]="!veraenderbar" [model]="exportKriterien.exportGrundstueckbeschreibung">
          </cap-select-grundstueckbeschreibung>
        </div>
      }
      <div class="col-6">
        @if (exportKriterien.mExportEigentum.access !== "DEACTIVATED") {
          <div>
            <cap-select-eigentum [disabled]="!veraenderbar" [model]="exportKriterien.exportEigentum"></cap-select-eigentum>
          </div>
        }
        <div class="mt-3">
          <cap-select-stammperson
            [disabled]="!veraenderbar || (exportKriterien.exportEigentum && !exportKriterien.exportEigentum.eigentum)"
            [model]="exportKriterien.exportStammperson">
          </cap-select-stammperson>
        </div>
      </div>
    </div>
  }
  @if (!readonly) {
    <div class="p-2" id="actionpane">
      <div class="rechtsbuendig">
        <button cdkStepperPrevious class="btn btn-outline-primary btn-actionpane" type="button">{{ "Zurück" | translate }}</button>
        <button class="btn btn-outline-primary" routerLink=".." type="button">{{ "Abbrechen" | translate }}</button>
        <button (click)="validateAndGoToNextStep()" class="btn btn-primary btn-actionpane" type="button">{{ "Weiter" | translate }}</button>
      </div>
    </div>
  }
</form>
